import { render } from "./popupfat.vue?vue&type=template&id=00943b00&scoped=true"
import script from "./popupfat.vue?vue&type=script&lang=js"
export * from "./popupfat.vue?vue&type=script&lang=js"

import "./popupfat.vue?vue&type=style&index=0&id=00943b00&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00943b00"]])

export default __exports__